import React from 'react';
import i18next from 'i18next';
import { Box, CircularProgress, Typography } from '@mui/material';

const PageLoader = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                minHeight: 'calc(100vh - 80px)',
                gap: 3,
                p: 4,
            }}
        >
            <Box
                sx={{
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        width: 90,
                        height: 90,
                        borderRadius: '50%',
                        border: '2px solid var(--color-primary)',
                        opacity: 0.2,
                        animation: 'pageLoaderPulse 1.5s ease-in-out infinite',
                        '@keyframes pageLoaderPulse': {
                            '0%': { transform: 'scale(0.8)', opacity: 0.5 },
                            '100%': { transform: 'scale(1.5)', opacity: 0 },
                        },
                    }}
                />

                <CircularProgress
                    size={64}
                    thickness={4}
                    sx={{
                        color: 'var(--color-primary)',
                        '& .MuiCircularProgress-circle': {
                            strokeLinecap: 'round',
                        },
                    }}
                />
            </Box>

            <Typography
                variant="h6"
                sx={{
                    color: 'var(--color-primary)',
                    fontWeight: 600,
                    letterSpacing: '0.5px',
                    textTransform: 'uppercase',
                    fontSize: '14px',
                }}
            >
                {i18next.t('caricamento')}...
            </Typography>

            <Typography
                variant="body2"
                sx={{
                    color: '#64748b',
                    fontSize: '13px',
                    textAlign: 'center',
                    maxWidth: 320,
                }}
            >
                {i18next.t('attendere_prego') || 'Stiamo preparando la pagina, un attimo di pazienza.'}
            </Typography>
        </Box>
    );
};

export default PageLoader;
